import React, { ReactNode } from "react"

import { ArrowRightIcon } from "@heroicons/react/24/outline"
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid"

import { Color } from "~tailwindui/types/enums"

import { H3, StyledLink } from "~tailwindui/Basics"
import Panel from "~tailwindui/Basics/Panel"
import { textColorClassNames } from "~tailwindui/helpers/classNameHelpers"

import classNames from "src/classNames"

export type ActionListProps = {
  title: string
  warning?: boolean
  hideOnEmpty?: boolean
  listItems: {
    icon: React.FC<any>
    path: string
    text: string
    active?: boolean
  }[]
  color: Color
}

const ActionList: React.FC<ActionListProps> = ({
  title,
  warning = false,
  hideOnEmpty = false,
  listItems,
  color,
}) => {
  const activeListItems = listItems.filter(Boolean)
  if (activeListItems.length === 0 && hideOnEmpty) return null

  return (
    <Panel className={classNames(warning && "!border-2 !border-red-500")}>
      <H3 className="mb-0 flex items-center rounded-sm p-1 text-xl font-bold uppercase">
        {title}
        {warning && (
          <ExclamationTriangleIcon className="ml-2 h-6 w-6 text-red-600" />
        )}
      </H3>
      <ul className="mx-4 divide-y text-lg">
        {activeListItems.length > 0 ? (
          activeListItems.map(({ icon: Icon, text, path, active }, idx) => (
            <li key={idx} className="flex items-center py-4">
              <Icon
                className={classNames(
                  "mr-3 inline-block h-8 w-8",
                  textColorClassNames({ color })
                )}
              />
              <StyledLink
                className={classNames(
                  "flex items-center",
                  active
                    ? `font-bold ${textColorClassNames({ color })}`
                    : "!text-inherit"
                )}
                to={path}
              >
                {text} <ArrowRightIcon className="ml-2 inline-block h-4 w-4" />
              </StyledLink>
            </li>
          ))
        ) : (
          <span>No items here</span>
        )}
      </ul>
    </Panel>
  )
}

export default ActionList
